@if (label()) {
  <span class="env-badge" [class]="'env-badge env-badge--' + env()">
    {{ label() }}
  </span>
}
